module.exports = __webpack_public_path__ + "media/images/credit_card-68a8695b3913c85b9ab0725ccb6a803e.svg";